import { AlertCircle, CheckCircle } from 'lucide-react';
import { Badge, BadgeColor } from './Badge';

/** Écritures issues d'un import FEC : livres déjà arrêtés, d'où le statut validé. */
export const FEC_ORIGIN_NOTE = 'Importé (FEC)';

interface ValidationStatusBadgeProps {
  status: 'awaitingValidation' | 'refused' | 'validated';
  /** Origin note shown under the badge — e.g. an écriture that came from a FEC import. */
  note?: string;
}

export function ValidationStatusBadge(props: ValidationStatusBadgeProps) {
  const { status, note } = props;

  function getStatusBadge(status: 'awaitingValidation' | 'refused' | 'validated') {
    switch (status) {
      case 'awaitingValidation':
        return {
          icon: <AlertCircle className="size-4" />,
          text: 'En attente de validation',
          color: BadgeColor.ORANGE,
        };
      case 'refused':
        return {
          icon: <AlertCircle className="size-4" />,
          text: 'Rejeté',
          color: BadgeColor.RED,
        };
      case 'validated':
        return {
          icon: <CheckCircle className="size-4" />,
          text: 'Validé',
          color: BadgeColor.GREEN,
        };
    }
  }

  const statusBadge = getStatusBadge(status);

  const badge = (
    <Badge icon={statusBadge.icon} color={statusBadge.color}>
      {statusBadge.text}
    </Badge>
  );

  if (!note) return badge;

  return (
    <div className="flex flex-col items-start gap-0.5">
      {badge}
      <span className="text-xs text-gray-500">{note}</span>
    </div>
  );
}
